import { ActionTypes as Type } from '../actions/actionLog';
import { convertDateToISO8601 } from '../lib/tools';
import { mediaType } from '../lib/constants';

const appInitialState = {
  logs: [],
  groups: [],
  operators: [],
  totalNumber: 0,
  totalPages: 0,
  searchOptions: {
    startDate: '',
    endDate: '',
    deviceName: null,
    operatorId: null,
    groupId: null,
    action: null,
  },
  limit: 100,
  page: 1,
  media: {
    type: mediaType.image,
    url: '',
  },
};

const truncateDate = date =>
  // 秒数以下を削除
  new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    0,
  );

export default (state = appInitialState, action) => {
  switch (action.type) {
    case Type.INIT_SEARCH_DATE: {
      const date = new Date();
      const toDate = truncateDate(date);
      const fromDate = truncateDate(date);
      fromDate.setDate(toDate.getDate() - 1);
      return {
        ...state,
        searchOptions: {
          ...appInitialState.searchOptions,
          startDate: convertDateToISO8601(fromDate),
          endDate: convertDateToISO8601(toDate),
        },
      };
    }
    case Type.SUCCESS_API_GET_ACTION_LOGS: {
      const { logs, totalNumber, totalPages } = action.payload;
      return { ...state, logs, totalNumber, totalPages };
    }
    case Type.SUCCESS_API_GET_GROUPS: {
      const { groups } = action.payload;
      return { ...state, groups };
    }
    case Type.SUCCESS_API_GET_OPERATORS: {
      const { operators } = action.payload;
      return { ...state, operators };
    }
    case Type.UPDATE_SEARCH_START_DATE: {
      const date = (action && action.date) || '';
      return {
        ...state,
        page: 1,
        searchOptions: { ...state.searchOptions, startDate: date },
      };
    }
    case Type.UPDATE_SEARCH_END_DATE: {
      const date = (action && action.date) || '';
      return {
        ...state,
        page: 1,
        searchOptions: { ...state.searchOptions, endDate: date },
      };
    }
    case Type.UPDATE_SEARCH_DEVICE_NAME: {
      return {
        ...state,
        page: 1,
        searchOptions: {
          ...state.searchOptions,
          deviceName: action.deviceName || null,
        },
      };
    }
    case Type.UPDATE_SEARCH_ACTION: {
      return {
        ...state,
        page: 1,
        searchOptions: {
          ...state.searchOptions,
          action: action.action || null,
        },
      };
    }
    case Type.UPDATE_SEARCH_GROUP: {
      return {
        ...state,
        page: 1,
        searchOptions: {
          ...state.searchOptions,
          groupId: action.groupId || null,
        },
      };
    }
    case Type.UPDATE_SEARCH_OPERATOR: {
      return {
        ...state,
        page: 1,
        searchOptions: {
          ...state.searchOptions,
          operatorId: action.operatorId || null,
        },
      };
    }
    case Type.UPDATE_SEARCH_PAGE: {
      return {
        ...state,
        page: action.page || null,
      };
    }
    case Type.UPDATE_MEDIA: {
      const type = action.media.type || mediaType.none;
      const url = action.media.url || '';
      return { ...state, media: { type: url ? type : mediaType.none, url } };
    }
    default:
      return state;
  }
};
